const closeWindow = function () {
    $$("mainLayout").hideProgress({});

    $$('helpWindow').close();
};

const frameHelp = {
    view: "window",
    move: true,
    id: "helpWindow",
    position: "top",
    allign: "right",
    fullscreen: true,
    head: {
        view: "toolbar", cols: [
            { view: "label", label: APPLOCALE.mainMenu.help.detail },
            { view: "button", label: APPLOCALE.button.btnClose, width: 100, align: 'right', click: closeWindow }
        ]
    },
    body: {
        view: "iframe",
        id: "frame-body",
        src: APPLANG == "ru-RU" ? "/assets/help.html" : (APPLANG == "hy-AM" ? "/assets/help_am.html" : "/assets/help_en.html"),
        gravity: 2,
    }
};

export default {
    $ui: frameHelp,
    $oninit: function () { }
};
